<template>
	 <div class="dialog-wrapper">       
        <div class="dialog-body">
            <div class="close" v-show="showicon" @click="cancel" ></div>
			<div class="title" v-show="!showImg">{{title}}</div>
            <div class="content" :class="{'text-content':!showImg}">
                <img src="../assets/tips.png" alt="" class="tips" v-show="showImg">
                <slot></slot>
            </div>
            <div class="btn">
                <div class="cancel" @click="cancel" v-show="showCancel">取消</div>
				<div class="confirm" @click="confirm">{{confirmbtn}}</div>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: "CustomerDialog",
		props: {
			 showImg:{
			    type:Boolean,
			    default:false
		    },		   
            showCancel: {
				type: Boolean,
				default: true
			},
			showicon: {
				type: Boolean,
				default: false
			},
			title: {
				type: String,
				default: "提示"
			},
			confirmbtn: {
				type: String,
				default: "确认"
			},
		},
		methods: {
			cancel() {
				this.$emit("cancel")
			},
			confirm() {
				this.$emit("confirm")
			}
		}
	}
</script>

<style scoped lang="scss">
	.dialog-wrapper {
		overflow: hidden;
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, 0.3);
		z-index: 100;
		.dialog-body {
			position: absolute;
			top: 40%;
			left: 50%;
			width: 74.67vw;
			margin-top: -20vw;
			margin-left: -37.33vw;
			border-radius: 2.67vw;
			background: #ffffff;
             .close{
				position: absolute;
				width: 8vw;
				height: 8vw;
				top: -12vw;
                right: 0;
                background: url("../assets/closepop.png") no-repeat center;
                background-size: 8vw;
			}
			.title{
				height: 12vw;
				line-height: 12vw;
				font-weight: bold;
                font-size: 4.8vw;
                text-align: center;
			}
            .content{
                padding: 4vw 1vw;
                text-align: center;
                img{
                    display: inline-block;
                }
                p{
                    text-align: center;
                }
            }
			.text-content{
				max-height: 30vh;
				padding: 0 6.67vw 8vw;
				overflow: scroll;
			}
            .tips{
                width: 24vw;
            }

			.btn {
				display: flex;
				border-top: .27vw solid #efefef;
				justify-content: space-around;
				div {
					height: 12vw;
					line-height: 12vw;
					flex-grow: 1;
				}

				.cancel {
					color: #666666;
					border-right: .27vw solid #efefef
				}

				.confirm {
					color: #3296fa;
				}
			}
		}
	}
</style>